import React from 'react';
import Icon from '../../../components/AppIcon';

import Button from '../../../components/ui/Button';

const AIRecommendations = ({ recommendations, onViewDetails }) => {
  const getRecommendationIcon = (type) => {
    const iconMap = {
      workout: 'Dumbbell',
      recovery: 'Heart',
      nutrition: 'Apple',
      class: 'Calendar',
      goal: 'Target'
    };
    return iconMap?.[type] || 'Sparkles';
  };

  const getRecommendationColor = (type) => {
    const colorMap = {
      workout: 'var(--color-primary)',
      recovery: 'var(--color-success)',
      nutrition: 'var(--color-accent)',
      class: 'var(--color-warning)',
      goal: 'var(--color-primary)'
    };
    return colorMap?.[type] || 'var(--color-primary)';
  };

  return (
    <div className="card">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-primary to-accent flex items-center justify-center">
          <Icon name="Sparkles" size={20} color="#FFFFFF" />
        </div>
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
            AI Recommendations
          </h2>
          <p className="text-sm text-muted-foreground">
            Personalized for your fitness journey
          </p>
        </div>
      </div>
      <div className="space-y-4">
        {recommendations?.map((recommendation) => (
          <div
            key={recommendation?.id}
            className="p-4 rounded-lg border border-border hover:border-primary/50 hover:shadow-md transition-all duration-250"
          >
            <div className="flex gap-4">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-primary/10 to-accent/10 flex items-center justify-center">
                  <Icon 
                    name={getRecommendationIcon(recommendation?.type)} 
                    size={24} 
                    color={getRecommendationColor(recommendation?.type)}
                  />
                </div>
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2 mb-2">
                  <h3 className="text-base font-medium text-foreground">
                    {recommendation?.title}
                  </h3>
                  <span className="text-xs text-primary font-medium whitespace-nowrap">
                    {recommendation?.confidence}% match
                  </span>
                </div>

                <p className="text-sm text-muted-foreground mb-3 line-clamp-2">
                  {recommendation?.description}
                </p>

                <div className="flex flex-wrap items-center gap-2 mb-3">
                  {recommendation?.tags?.map((tag, index) => (
                    <span
                      key={index}
                      className="px-2 py-1 rounded-full bg-muted text-xs text-foreground"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3 text-xs text-muted-foreground">
                    <span className="flex items-center gap-1">
                      <Icon name="Clock" size={12} />
                      {recommendation?.duration}
                    </span>
                    <span className="flex items-center gap-1">
                      <Icon name="TrendingUp" size={12} />
                      {recommendation?.difficulty}
                    </span>
                  </div>

                  <Button
                    variant="ghost"
                    size="sm"
                    iconName="ArrowRight"
                    iconPosition="right"
                    onClick={() => onViewDetails(recommendation?.id)}
                  >
                    View
                  </Button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 rounded-lg bg-gradient-to-r from-primary/5 to-accent/5 border border-primary/20">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm text-foreground font-medium mb-1">
              How AI recommendations work
            </p>
            <p className="text-xs text-muted-foreground">
              Our AI analyzes your workout history, goals, fitness level, and recovery patterns to suggest personalized programs that maximize your results while preventing injury.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIRecommendations;